<template lang="pug">
	b-container.susbcribe-page-redesign(fluid)
		b-row.xy-row(v-if="$route.query.xypn")
			b-container(fluid)
				b-row
					b-col(md="2" sm="2" cols="12")
						b-img(:src="`${$store.state.config.s3ResourceHost}/images/logo-xy-planning.png`" alt="XY Planning")
					b-col(md="10" sm="10" cols="12")

						h3.section-title
							| Welcome XY Planning Network members!
						p
							| New subscribers who are members of the XY Planning Network are eligible for a 30-day free trial when they sign up for a yearly subscription at the Gold or Platinum levels. Plus, you enjoy a 10% discount on the annual subscription price. Any questions? Please contact us at&nbsp;
							a(href="mailto:support@savingforcollege.com") support@savingforcollege.com.
		b-row.xy-row(v-if="$route.query.capstone")
			b-container(fluid)
				b-row
					b-col(md="4" sm="6" lg="2" cols="12")
						b-img(:src="`${$store.state.config.s3ResourceHost}/images/logo-capstone.png`" alt="Capstone")
					b-col(md="8" sm="6" lg="10" cols="12")

						h3.section-title
							| Welcome!
						p
							| As a College Pre-Approval™ Pro, you are eligible for 50% off of your first year's subscription when you sign up for a yearly subscription at the Gold or Platinum level. This discount - the largest we have ever offered - is exclusively available to you through our partnership with College Pre-Approval™. Any questions? Please contact us at&nbsp;
							a(href="mailto:support@savingforcollege.com") support@savingforcollege.com.
		b-row
			b-col(md="12")
				b-alert(class="general" :show="showAlertMessage" dismissible :variant="generalClass" @dismissed="showAlertMessage=false")
					b-row
						b-col(md="1" sm="1" cols="2")
							b-img.alert-img(src="https://web-resources.savingforcollege.com/images/icon_error.png" fluid alt="Error Icon")
						b-col(md="10" sm="10" cols="8")
							.alert-heading
								| {{generalMessageHeader}}
							p
								| {{generalMessageBody}}
				b-row
					b-col.left(md="5" lg="6" sm="12")
						b-row
							b-col(md="9" sm="10"  offset-md="2" offset-sm="1" offset="1"  cols="10")
								h1.first Grow your practice with our premium 529 tools
								p.grow-your-practice
									| Take it to the next level. Get the knowledge you need to address your client's college planning concerns with a premium subscription to Savingforcollege.com.
								ul.subscription-offer
									li
										.checkmark.green
										| Exclusive content for financial professionals
									li
										.checkmark.green
										| 529 performance rankings and fee studies
									li
										.checkmark.green
										| In-depth 529 investment portfolio data and comparisons
									li
										.checkmark.green
										| Look-up tool for sales charges and breakpoint schedules
									li
										.checkmark.green
										| A suite of calculators with downloadable reports
									li
										.checkmark.green
										| Practice-building resources
									li
										.checkmark.green
										| Biweekly newsletter
									li
										h3.simple Gold &amp; Platinum subscribers get

									li
										.checkmark.green
										| Access to the Pro 529 Evaluator tool
									li
										.checkmark.green
										| A listing in our Directory of Financial Professionals
									li
										.checkmark.green
										| Complimentary ads on Savingforcollege.com
								b-row.testimonial
									b-col(md="3" lg="2" sm="3" cols="4")
										b-img.img-responsive(src="https://web-resources.savingforcollege.com/images/nannete_kamien_headshot.jpg" rounded="circle"  blank-color="#777" alt="Nannette Kamien" class="m-1")
									b-col(md="9" lg="10" sm="9" cols="8")
										p
											| "This Pro 529 Evaluator is great. It was super easy for me to compare my client's current plan to the 529 I would recommend and show him that he can save almost $10,000 in fees over the next 14 years. That's huge!"
											br
											br
											| Nannette Kamien
											br
											| Inspiration Financial Planning
					b-col.right(md="7" lg="5" sm="12")

						h1.first
							| Select your subscription
						h3.simple
							| Billing Cycle
						.button-choices
							b-row
								b-col
									b-button.sfc-blue-choice(:class="{'active': typeOfSubscription == 'monthly' }" @click="changeTypeOfSubscription('monthly')")
										| Monthly
								b-col(v-if="!$route.query.capstone")
									b-button.sfc-blue-choice(:class="{'active': typeOfSubscription == 'yearly' }" @click="changeTypeOfSubscription('yearly')")
										| Yearly - 30% OFF
								b-col(v-if="$route.query.capstone")
									b-button.sfc-blue-choice(:class="{'active': typeOfSubscription == 'yearly' }" @click="changeTypeOfSubscription('yearly')")
										| Yearly
						div
							b-row
								b-col(cols="12")
									h3.simple
										| Subscription
								b-col(cols="12")
									.text-right
										label.checkbox-container.mr-3
											input(type="checkbox" id="discount" v-model="getDiscount" @change="toggleCoupon")
											span.checkmark-container
												span.checkmark.green
										| Apply discount code
							.tb(v-if="getDiscount")
								label(for="discount-input" :class="{'not-empty': !couponCode == '' }")

									input(id="discount-input" type="text" v-model.trim="couponCode" @input="couponCodeChanged")
									span.floaty-label
										| Discount Code
									span.input-right.text(v-show="showDiscountLinks")
										span(v-if="validCouponCodeApplied" @click="removeDiscount")
											| Remove discount
										span(v-else @click="verifyCoupon")
											| Apply discount
									.error(v-if="couponError")
										| {{couponErrorMessage}} Invalid discount code. Try again.
						b-form-group.subscriptions(v-if="typeOfSubscription == 'monthly'")
							b-form-radio-group(v-model="selectedMonthlyPlan" name="subscription_id" @input="showAlertMessage=false")
								label(for="card_one")
									b-card(:class="{'chosen': selectedMonthlyPlan == '1'}")
										b-row
											b-col(md="1" sm="1" cols="2")
												b-form-radio(id="card_one" value="1")
												
											b-col(md="10" sm="10" cols="9")
												h4.card-title
													| Basic
												h4.card-title
													| $25/month&nbsp;
													span.green-text
														| {{basicMonthlyBenefits}}
												p Access all 529 plan data - performance, expenses and commissions, underlying funds - and premium calculators.
								label(for="card_two")
									b-card(:class="{'chosen': selectedMonthlyPlan == '10'}")
										b-row
											b-col(md="1" sm="1" cols="2")
												b-form-radio(id="card_two" value="10")

											b-col(md="10" sm="10" cols="9")
												h4.card-title
													| Gold Financial Pro
													.tag.gold
														| Best Value
												h4.card-title
													| $35/month&nbsp;
													span.green-text
														| {{goldFinancialProMonthlyBenefits}}
												p Grow your practice with college savings expertise: includes all benefits of Basic, plus a Pro Directory listing, practice-building resources, and access to the Pro 529 Evaluator.
								label(for="card_three")
									b-card(:class="{'chosen': selectedMonthlyPlan == '12'}")
										b-row
											b-col(md="1" sm="1" cols="2")
												b-form-radio(id="card_three" value="12")
											b-col(md="10" sm="10" cols="9")
												h4.card-title
													| Platinum Financial Pro
												h4.card-title
													| $99/month&nbsp;
													span.green-text
														| {{platinumFinancialProMonthlyBenefits}}
												p Stand out from the crowd: Highlight your practice with a featured listing in our Pro Directory, plus enjoy all of the benefits of Basic and Gold subscribers.
						b-form-group.subscriptions(v-else)
							b-form-radio-group(v-model="selectedYearlyPlan" name="subscription_id" @input="showAlertMessage=false")
								label(for="card_one_b")
									b-card(:class="{'chosen': selectedYearlyPlan == '2'}")
										b-row
											b-col(md="1" sm="1" cols="2")
												b-form-radio(id="card_one_b" value="2")
											b-col(md="10" sm="10" cols="9")
												h4.card-title
													| Basic
												h4.card-title
													| $199/year&nbsp;
													span.green-text
														| {{basicYearlyBenefits}}
												p Access all 529 plan data - performance, expenses and commissions, underlying funds - and premium calculators.
								label(for="card_two_b")
									b-card(:class="{'chosen': selectedYearlyPlan == '3'}")
										b-row
											b-col(md="1" sm="1" cols="2")
												b-form-radio(id="card_two_b" value="3")
											b-col(md="10" sm="10" cols="9")
												h4.card-title
													| Gold Financial Pro
													.tag.gold
														| Best Value
												h4.card-title
													| $299/year&nbsp;
													span.green-text
														| {{goldFinancialProYearlyBenefits}}
												p Grow your practice with college savings expertise: includes all benefits of Basic, plus a Pro Directory listing, practice-building resources, and access to the Pro 529 Evaluator.
								label(for="card_three_b")
									b-card(:class="{'chosen': selectedYearlyPlan == '7'}")
										b-row
											b-col(md="1" sm="1" cols="2")
												b-form-radio(id="card_three_b" value="7")
											b-col(md="10" sm="10" cols="9")
												h4.card-title
													| Platinum Financial Pro
												h4.card-title
													| $749/year&nbsp;
													span.green-text
														| {{platinumFinancialProYearlyBenefits}}
												p Stand out from the crowd: Highlight your practice with a featured listing in our Pro Directory, plus enjoy all of the benefits of Basic and Gold subscribers.
						.radio-container.user-type
							h2 User Type
							b-form-radio-group(:class="{error:userSelectError}" v-model="selectedUserType" @input="showAlertMessage=false;validUserTypeSelection()")
								
								b-form-radio(id="radio_a" name="typeOfUser" value="Professional")
									b-col
										.radio-title
											|  Professional
										.radio-p
											| I help clients with their college savings planning, or work in the industry
								b-form-radio(id="radio_b" name="typeOfUser" value="Personal")
									b-col
										.radio-title
											| Personal
										.radio-p
											| I'm interested in saving for college for myself or my children
						div
							h2 Create your log in credentials
							.login-credentials
								b-row
									b-col(md="6")
										.tb(:class="{'error' : errors.has('email') && fields.email.touched }")
											label(for="email" :class="{'not-empty': email != '' }")
												input(id="email" type="text" v-model.trim="email" name="email" v-validate="'required|email|userEmailNotTaken'")
												span.floaty-label
													| Email
												.error(v-show="errors.has('email') && fields.email.touched")
													| {{ errors.first('email') }}
									b-col(md="6")
										.tb(:class="{'error' : errors.has('username') && fields.username.touched}")
											label(for="username" :class="{'not-empty': username != '' }")
												input(id="username" type="text" v-model.trim="username" name="username" v-validate="'required|min:8|validUsername|validUsernameNoAt|usernameNotTaken'")
												span.floaty-label
													| Username
												.error(v-show="errors.has('username') && fields.username.touched")
													| {{ errors.first('username') }}

								b-row
									b-col(md="6")
										.tb(:class="{'error' : errors.has('password') && fields.password.touched,'blue-error': password.length < 6 && password.length > 1}")
											label(for="password" :class="{'not-empty': password != '' }")
												input(id="password" type="password" v-model="password" name="password" v-validate="'required|min:6'")
												span.floaty-label
													| Password
												.error(v-show="errors.has('password') && fields.password.touched")
													| {{ errors.first('password') }}

									b-col(md="6")
										.tb(:class="{'error' : errors.has('passwordConfirmation') && fields.passwordConfirmation.touched }")
											label(for="pw-confirm" :class="{'not-empty': passwordConfirmation != '' }")
												input(id="pw-confirm" type="password" v-model="passwordConfirmation" v-validate="{is:password, required:true}" name="passwordConfirmation")
												span.floaty-label
													| Confirm Password
												.error(v-show="errors.has('passwordConfirmation') && fields.passwordConfirmation.touched")
													| {{ errors.first('passwordConfirmation') }}
						div
							h2 Contact Info
							b-row
								b-col
									.tb(:class="{'error' : errors.has('phoneNumber') && fields.phoneNumber.touched}")
										label(for="phone-number" :class="{'not-empty': phoneNumber != '' }")
											input#phone-number(type="text" name="phoneNumber" v-model.trim="phoneNumber" v-validate="'required|numeric|min:10'")
											span.floaty-label
												| Phone Number
											.error(v-show="errors.has('phoneNumber') && fields.phoneNumber.touched")
												| {{ errors.first('phoneNumber') }}
						div
							h2
								| Billing Info
							.billing-info
								b-row
									b-col(md="6" sm="6" cols="6")
										.tb(:class="{'error' : errors.has('firstName') && fields.firstName.touched}")
											label(for="first-name" :class="{'not-empty': firstName != '' }")
												input.special-hp(id="full-name" type="text" name="fullName" placeholder="Full Name" ref="fullName" value="")
												input(id="first-name" type="text" name="firstName" v-model.trim="firstName" v-validate="'required'")
												span.floaty-label
													| First Name
												.error(v-show="errors.has('firstName') && fields.firstName.touched")
													| {{ errors.first('firstName') }}
									b-col(md="6" sm="6" cols="6")
										.tb(:class="{'error' : errors.has('lastName') && fields.lastName.touched}")
											label(for="last-name" :class="{'not-empty': lastName != '' }")
												input(id="last-name" type="text" name="lastName" v-model.trim="lastName" v-validate="'required'")
												span.floaty-label
													| Last Name
												.error(v-show="errors.has('lastName') && fields.lastName.touched")
													| {{ errors.first('lastName') }}
									b-col(md="12")
										.tb(:class="{'error' : errors.has('cardNumber') && fields.cardNumber.touched }")
											label(for="card-num" :class="{'not-empty': cardNumber != '' }")
												masked-input(id="card-num" type="text" name="cardNumber" v-model="cardNumber" :guide="false" :mask="[/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]" v-validate="'required|validCardNumber'" @input="setCardType")
												span.floaty-label
													| Card Number
												span.card-type(v-if="cardType!='unknown'" :style="`background: url('https://web-resources.savingforcollege.com/images/images/${cardType}.png') no-repeat;  height: 30px;width: 50px;backgroundSize: contain; backgroundPosition:  center center;`")
												.error(v-show="errors.has('cardNumber') && fields.cardNumber.touched")
													| {{ errors.first('cardNumber') }}
									b-col(md="4" sm="4" cols="4")
										.tb.exp(:class="{'error' : errors.has('expiration') && fields.expiration.touched }")
											label(for="exp" :class="{'not-empty': expiration != '' }")
												masked-input(id="exp" type="text" name="expiration" v-model.trim="expiration" :guide="true" placeholder="MM/YYYY" placeholderChar="-" :mask="[/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]" v-validate="'required|validExpirationDate'")
												span.floaty-label
													| Expiration
												.error(v-show="errors.has('expiration') && fields.expiration.touched")
													| {{ errors.first('expiration') }}
									b-col(md="4" sm="4" cols="4")
										.tb(:class="{'error' : errors.has('cvc') && fields.cvc.touched}")
											label(for="cvc" :class="{'not-empty': cvc != '' }")
												masked-input(id="cvc" type="text" name="cvc" v-model.trim="cvc" :guide="false" :mask="[/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]" v-validate="'required|validCvc'")
												span.floaty-label
													| CVC
												.error(v-show="errors.has('cvc') && fields.cvc.touched")
													| {{ errors.first('cvc') }}
									b-col(md="4" sm="4" cols="4")
										.tb(:class="{'error' : errors.has('zipCode') && fields.zipCode.touched}")
											label(for="zip" :class="{'not-empty': zipCode != '' }")
												input(id="zip" type="text" name="zipCode" v-model.trim="zipCode" v-validate="'required|validZipCode'")
												span.floaty-label
													| Zip Code
												.error(v-show="errors.has('zipCode') && fields.zipCode.touched")
													| {{ errors.first('zipCode') }}
						div
							.button-box
								sfc-simple-button.button-submit(text="Continue" :blue="true" @click="submitForm" :disabled="this.loading")
									//span
										clip-loader(v-if="loading" :loading="loading" :color="color" :size="size")

						div
							p.disclaimer
								| By clicking "Continue" you agree to the savingforcollege.com&nbsp;
								a(href="https://www.savingforcollege.com/terms_of_use/" target="_blank") terms and conditions
								| . Your subscription will be activated immediately and will be renewed {{subscriptionPaymentAmount}} on {{subscriptionNextPaymentDate}} unless you cancel prior to that date.
						img(v-if="activePlan1or2" height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=96116&conversionId=166450&fmt=gif")
						img(v-if="activePlan3or10" height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=96116&conversionId=170122&fmt=gif")
						img(v-if="activePlan7or12" height="1" width="1" style="display:none;" alt="" src="https://dc.ads.linkedin.com/collect/?pid=96116&conversionId=170114&fmt=gif")
		b-modal(id="upgrade-modal" ref="upgradeModal" title="Get more out your subscription" :hide-footer="true"  :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" centered)
			b-row
				b-col
					h4
						| {{upgradePlanHeadLine}}
					p
						| {{upgradePlanDescription}}
					div.upgrade-img
					h4 Unlock access to
					ul.checkmark-list
						li
							.checkmark.green
							| The Pro 529 Evaluator tool
						li
							.checkmark.green
							| A listing in our Directory of Financial Professionals
						li
							.checkmark.green
							| Complimentary ads on Savingforcollege.com
					br

			b-row
				b-col
					h4 Would you like to upgrade?
			b-row.modal-button-row
				b-col
					b-button.sfc-blue(@click="closeModal('No upgrade');")
						| No
				b-col
					b-button.sfc-blue(@click="upgradePlan")
						| Yes

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	p.grow-your-practice
		font-size: body-font-size-md
	.checkbox-container
		width 22px
		height 22px
		cursor pointer
		margin 0
		position relative
		input
			position absolute
			opacity 0
			cursor pointer
			-webkit-user-select none
			-moz-user-select none
			-ms-user-select none
			user-select none
			& ~ .checkmark-container
					.checkmark
						opacity 0
			&:checked
				& ~ .checkmark-container
						border-color success-green
						.checkmark
							opacity 1
		.checkmark
			transition-all()
			position relative
			top: -5px
			right: 3px
			@media (max-width: 575px)
				top: -9px
	.checkmark-container
		transition-all()
		height 22px
		border 1px solid sfc-pale-gray
		width: 100%
		display: block
	>>> .custom-radio
		.custom-control-label
			&::after
				left: -20px !important
	>>>	.custom-checkbox
		.checkmark
			left: -20px !important

	.special-hp
		display: none

	.tb
		.not-empty
			input
				padding-right: 115px

	.upgrade-img
		background: url('https://web-resources.savingforcollege.com/images/upgrade.png') no-repeat
		background-size: contain
		height: 200px
		width: 100%
		margin: 30px 0

	.tb.exp
			label
				input
					&::placeholder
						color: #fff
					&:focus
						&::placeholder
							color: gray-40
	.modal-button-row
		button
			width: 100%
	.xy-row
		padding: 25px 0
		border-bottom: 1px solid sfc-pale-gray
		background: bg-gray
		> .container-fluid
			max-width: 90%
		p
			margin-bottom: 0
		img
			max-height: 80px
			max-width: 100%
			margin-bottom: 15px
	.right
		margin: 0 auto
		padding 50px 30px
		.sfc-blue-choice
			border: 1px solid blue-primary !important
			color: blue-primary !important
			text-transform: uppercase
			font-family: main-font!important
		button.sfc-blue
			margin-top: 45px
		.card-type
			background-position: center center
			background-size: contain!important
		h3
			margin-bottom: 0
		h2
			margin-top: 45px
			font-size: 25px!important
		h1
			font-size: 31px!important
		h1.first
			margin-bottom: 30px
			margin-top: 0
		.user-type
			>>> .custom-radio
				.custom-control-label
					&::after
						left: -11px !important
						top: 7px !important
			.radio-title
			.radio-p
				font-size: 16px!important
				line-height: 1.6
		label
			vertical-align: sub
		.subscriptions
			margin-top: 0px
			>>> .custom-radio
				.custom-control-label
					&::after
						left: -11px !important
						top: 6px !important
			label
				width: 100%
				display: block
				cursor: pointer
				margin 20px 0
				&:first
					margin-top: 0px
				.card
					transition-all()
					p
						margin-bottom: 0
					&.chosen
						border: 1px solid blue-primary!important
						background: blue-20 !important
						color: blue-90!important
						h4.card-title
							color: sfc-blue-hover
							.green-text
								color: body-font-color-black
							.tag
								background: sfc-blue-link
								border: 1px solid sfc-blue-border
								color: #fff
						p
							color: sfc-blue
				h4.card-title
					font-size: body-font-size-lg
					.tag
						float:right
				p
					font-size: body-font-size-md
		.custom-checkbox
			float right
		.disclaimer
			margin: 20px 0
			font-size: body-font-size
			color: #acacac!important
			a
				color: sfc-pale-gray
				text-decoration: underline
				cursor: pointer
		.button-box
			text-align: right
			width: 200px
			padding: 24px 0
	.left
		padding 50px 0
		margin-left -2%
		background bg-gray
		border-right 1px solid sfc-pale-gray
		h2
			font-size: 25px!important
		> .row
			position sticky
			top 20px
			margin: 0 auto
		ul.subscription-offer
			list-style none
			padding-left 0
			margin-bottom 50px
			li
				font-size: body-font-size-md
				line-height: 2
				h3
					margin-top: 30px
				.tag
					display inline-block
					margin-right 10px
					margin-left 5px
			.checkmark
				position relative
				top -3px
				margin-right 15px
		.testimonial
			p
				font-size: body-font-size-md
			img
				max-width: 100%

@media screen and (max-width: 768px)
	.left
		margin-left: 0px
		border-right: 0px
		border-bottom: 1px solid sfc-pale-gray
</style>

<script>
	import Vue from 'vue';
	import VeeValidate, { Validator, mapFields } from 'vee-validate'
	import MaskedInput from 'vue-text-mask'
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import SfcUtil from "@/lib/sfc-util.js"
	import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'

	Vue.use(VeeValidate);

	export default {

		layout: 'redesign-v1/subscribe',

		components: {
			MaskedInput,
			ClipLoader,
			SfcSimpleButton
		},

		data(){

			const dictionary = {
				en: {
					messages:{
						required: () => 'Required',
						email: () => 'Invalid email'
					},

					custom:{
						password:{
							min: () => "Minimum 6 characters"
						},

						passwordConfirmation:{
							min: () => "Minimum 8 characters",
							is: () => "Passwords don't match"
						},

						zipCode: {
							min: () => "Invalid zip code",
							max: () => "Invalid zip code",
							numeric: () => "Invalid zip code",
						},

						username:{
							min: () => "Minimum 8 characters",
							alpha_num: () => "Username should be alphanumeric only"
						},

						phoneNumber:{
							numeric:() => 'Invalid phone number, only numbers allowed',
							min: () => 'Invalid phone number'
						}

					}
				}
			}

			Validator.localize(dictionary);

			return{
				password: "",
				passwordConfirmation: "",
				typeOfSubscription: 'monthly',
				selectedMonthlyPlan: null,
				selectedYearlyPlan: null,
				validateOnChange: false,
				email: "",
				username: "",
				firstName: "",
				lastName: "",
				cardNumber: "",
				expiration: "",
				phoneNumber: "",
				selectedUserType: undefined,
				userSelectError: false,
				cvc: "",
				zipCode: "",
				disabled: true,
				couponCode: "",
				couponError: false,
				couponErrorMessage: "",
				allSubscriptions: {},
				currentCouponResponse: undefined,
				showErrorMessages: false,
				getDiscount: false,
				stripeObject: null,
				complete: false,
				showAlertMessage: false,
				loading: false,
				color: "#fff",
				size: "20px",
				generalMessageBody: "",
				generalMessageHeader: "",
				generalClass: "danger",
				stripeOptions: {
				},
				cardType: "unknown",
				activePlan1or2: false,
				activePlan3or10: false,
				activePlan7or12: false,
				validCouponCodeApplied: false,
				showDiscountLinks: false,
				planSelectError: "",
				modalAlreadyShow: false,
				upgradePlanName: "",
				upgradePlanDescription: "",
				upgradePlanHeadLine: "",
				firstSfcServerCall: true
			}
		},

		mounted(){
			this.trackAnalyticsPageLoad()
			Stripe.setPublishableKey(this.$store.state.config.stripeKey)

			Validator.extend('validCardNumber', {
				getMessage: field => 'Invalid card number',
				validate: value => {
					let valueToAsk = value
					return Stripe.card.validateCardNumber(valueToAsk)
				}
			});

			Validator.extend('validExpirationDate', {
				getMessage: field => 'Invalid expiration date',
				validate: value => {
					try {
						const month = value.split("/")[0]
						const year = value.split("/")[1]
						return Stripe.card.validateExpiry(month, year)
					}catch (e) {
						true
					}
				}
			});

			Validator.extend('validCvc', {
				getMessage: field => 'Invalid cvc code',
				validate: value => {
					return Stripe.card.validateCVC(value)
				}
			});

			Validator.extend('validUsername', {
				getMessage: field => 'First character must be alphanumeric',
				validate: value => {
					const regex = /^[0-9a-zA-z]+/
					return regex.test(value)
				}
			});

			Validator.extend('validUsernameNoAt', {
				getMessage: field => "Can't contain \"@\" character",
				validate: value => {
					return !value.includes("@")
				}
			});

			Validator.extend('validZipCode', {
				getMessage: field => 'Invalid zip code',
				validate: value => {
					const regex = /^\d{4,5}(?:[-\s]\d{4})?$/
					return regex.test(value)
				}
			});

			this.$validator.extend('usernameNotTaken', {
				getMessage: field => 'Username is already taken',
				validate: value => {
					if(this.firstSfcServerCall){
						return new Promise( async resolve => {
							const query = `
							query{
								username_available(username: "${this.username}")
							}
						`
							const response = await this.$httpService.graphql(query)
							resolve(
								response.data.username_available
							)
						})
					}else{
						return true
					}

				}
			});

			this.$validator.extend('userEmailNotTaken', {
				getMessage: field => 'Email is already taken',
				validate: value => {
					if(this.firstSfcServerCall) {
						return new Promise(async resolve => {
							const query = `
								query{
									email_available(email: "${this.email}")
								}
							`
							const response = await this.$httpService.graphql(query)
							resolve(
								response.data.email_available
							)
						})
					} else {
						return true
					}
				}
			});


		},

		created(){

			if (['2','3','7'].includes(this.$route.query.subscription_id)){
				this.typeOfSubscription = 'yearly'
				this.selectedYearlyPlan = this.$route.query.subscription_id
			}else{
				this.typeOfSubscription = 'monthly'
				this.selectedMonthlyPlan = this.$route.query.subscription_id
			}

			this.couponCode = this.$route.query.subscription_coupon
			this.verifyCoupon()


		},

		computed:{
			basicMonthlyBenefits(){
				return this.couponBenefitText(1)
			},

			goldFinancialProMonthlyBenefits(){
				return this.couponBenefitText(10)
			},

			platinumFinancialProMonthlyBenefits(){
				return this.couponBenefitText(12)
			},

			basicYearlyBenefits(){
				return this.couponBenefitText(2)
			},

			goldFinancialProYearlyBenefits(){
				return this.couponBenefitText(3)
			},

			platinumFinancialProYearlyBenefits(){
				return this.couponBenefitText(7)
			},

			subscriptionPaymentAmount(){
				if (this.typeOfSubscription == 'monthly'){
					if(this.selectedMonthlyPlan == '1'){
						return "for $25"
					}
					if(this.selectedMonthlyPlan == '10'){
						return "for $35"
					}
					if(this.selectedMonthlyPlan == '12'){
						return "for $99"
					}
				} else {
					if(this.selectedYearlyPlan == '2'){
						return "for $199"
					}
					if(this.selectedYearlyPlan == '3'){
						return "for $299"
					}
					if(this.selectedYearlyPlan == '7'){
						return "for $749"
					}
				}
			},

			subscriptionNextPaymentDate(){
				let nextPaymentDate
				if(this.typeOfSubscription == 'monthly'){
					nextPaymentDate = new Date().setMonth(new Date().getMonth() + 1)
				}else{
					nextPaymentDate = new Date().setFullYear(new Date().getFullYear() + 1)
				}
				return SfcUtil.utcDateToHuman(nextPaymentDate)
			}
		},

		methods:{
			showModal () {
				this.modalAlreadyShow = true
				this.$refs.upgradeModal.show()
			},

			closeModal (upgrade) {
				this.$refs.upgradeModal.hide()
				// Given that the modal closes only when user clicks on yes or no then we should continue the execution
				this.trackUpsell(upgrade)
				this.submitForm()
			},

			countDownChanged (dismissCountDown) {
				this.dismissCountDown = dismissCountDown
			},

			showAlert () {
				this.showAlertMessage = true
			},

			couponBenefitText(promotionId){
				try{
					return this.allSubscriptions[`${promotionId}`].benefits_text
				}catch (e) {
					return ""
				}
			},

			couponCodeChanged(){
				if(this.validCouponCodeApplied){
					this.removeDiscount()
				}
			},

			removeDiscount(){
				this.couponError = false
				this.couponErrorMessage = ""
				this.allSubscriptions = {}
				this.validCouponCodeApplied = false
				this.couponCode = ""
			},

			toggleCoupon(){
				setTimeout( () =>{
					if (!this.getDiscount) {
						this.removeDiscount()
					}
				}, 0)
			},

			async verifyCoupon(){
				this.couponError = false
				this.couponErrorMessage = ""
				this.allSubscriptions = {}

				if (!this.couponCode || this.couponCode == ""){
					this.showDiscountLinks = true
					return
				}
				this.getDiscount = true
				const params = {
					mode: "validate_coupon",
					subscription_coupon: this.couponCode,
					order_id: this.$route.query.order_id,
					trial_days: this.$route.query.trial_days,
					user_logged_in: this.$store.state.userIsLoggedIn,
					user_id: this.$store.state.userId
				}
				const url = `${this.$store.state.config.sfcHost}/subscriptions/process_signup.php`
				const response = await this.$httpService.get(url, params)
				if(!response.success){
					this.couponError = true
					this.couponErrorMessage = response.error
				}else{
					this.currentCouponResponse = response.subscription_coupon
					this.allSubscriptions = response.all_subscriptions
					this.validCouponCodeApplied = true
					if(this.couponCode.toLowerCase().includes("year")){
						this.changeTypeOfSubscription('yearly')
					}else{
						if(this.couponCode.toLowerCase().includes("month")){
							this.changeTypeOfSubscription('monthly')
						}
					}
				}
				this.showDiscountLinks = true
			},

			trackAnalyticsPageLoad(){
				setTimeout(() => {
					if(this.$route.query.xypn){
						SfcTrackingService.trackSubscriptionPageLoad("xypn")
					}else{
						if(this.$route.query.capstone){
							SfcTrackingService.trackSubscriptionPageLoad("capstone")
						}else{
							SfcTrackingService.trackSubscriptionPageLoad()
						}
					}
				}, 2000)
			},
			trackUpsell(upgrade){
				SfcTrackingService.trackSubscribePage('upsell', upgrade)
			},

			changeTypeOfSubscription(type){
				this.typeOfSubscription = type
			},

			validPlanSelection(){
				this.planSelectError = false
				if(this.validateOnChange){
					if(this.typeOfSubscription == 'monthly'){
						if (!this.selectedMonthlyPlan) {
							this.planSelectError = true
							this.generalMessageBody = 'Please select one plan'
							this.generalMessageHeader = 'Whoops!'
							this.generalClass = 'danger'
							this.showAlert()
						}
					}else{
						if (!this.selectedYearlyPlan){
							this.planSelectError = true
							this.generalMessageBody = 'Please select one plan'
							this.generalMessageHeader = 'Whoops!'
							this.generalClass = 'danger'
							this.showAlert()
						}
					}
				}
				return !this.planSelectError
			},

			validUserTypeSelection(){
				this.userSelectError = false
				if(this.validateOnChange){
					if (!this.selectedUserType) {
						this.generalMessageBody = 'Please select your type of user'
						this.generalMessageHeader = 'Whoops!'
						this.generalClass = 'danger'
						this.showAlert()
						this.userSelectError = true
					}
				}
				return !this.userSelectError
			},

			setAllFieldsTouched(){
				const fields = Object.entries(this.fields).map( value => value[0])

				for(let field of fields){
					this.$validator.flag(field, {
						touched: true,
						untouched: false,
					})
				}
			},

			upgradePlan(){
				if(this.typeOfSubscription == 'monthly'){
					if(this.selectedMonthlyPlan == '1'){
						this.selectedMonthlyPlan = '10'
						if(!this.validCouponCodeApplied || this.couponCode != "MONTHLY-ALL-INVITE50"){
							this.couponCode = "MONTHLY-ALL-INVITE50"
							this.verifyCoupon()
						}
					}
				}
				this.closeModal("yes upgrade")
			},

			couponValidForUpgrade(){
				const couponArray = ["YEARLY-ALL-SAVE10", "YEARLY-GOLDPLATINUM-INVESTOPEDIA", "YEARLY-GOLDPLATINUM-XYPN", "YEARLY-GOLDPLATINUM-FPA", "MONTHLY-ALL-INVITE50"]
				if(couponArray.indexOf(this.couponCode) != -1){
					return true
				}
				return false
			},

			isUpgradeCandidate(){
				if(this.couponValidForUpgrade() || !this.validCouponCodeApplied) {
					if (this.typeOfSubscription == 'monthly') {
						if (this.couponCode == "MONTHLY-ALL-INVITE50"){
							if (this.selectedMonthlyPlan == '1') {
								this.upgradePlanName = "Gold"
								let discountText
								if(this.currentCouponResponse.coupon_type == 'percent'){
									discountText = `${this.currentCouponResponse.amount}%`
								}else{
									discountText = `$${this.currentCouponResponse.amount}`
								}
								this.upgradePlanDescription = `With ${discountText} off the first 30 days, you pay only ${Vue.filter('currency')(this.allSubscriptions['10'].price, "$", 2)} today!`
								this.upgradePlanHeadLine = `Upgrade to ${this.upgradePlanName} today for only $${this.allSubscriptions['10'].original_price - this.allSubscriptions['1'].original_price} more per month`
								return true
							}
						}else{
							if (this.selectedMonthlyPlan == '1') {
								this.upgradePlanName = "Gold"
								const discountText = `50%`
								this.upgradePlanDescription = `Enjoy the benefits of a Gold subscription and pay only $17.50 for your first 30 days! After 30 days, you will be charged at the standard rate of $35 per month as long as you are subscribed.`
								this.upgradePlanHeadLine = `Upgrade to Gold today and save 50% on your first 30 days`
								return true
							}
						}
					}
				}
				return false
			},

			async submitForm(){

				if (this.$refs.fullName && this.$refs.fullName.value && this.$refs.fullName.value != ""){
					const value = this.$refs.fullName.value
					const url = location.href
					const queryHP = `
						mutation {
							add_ip_to_honeypot_list(value: "${value}", url: "${url}")
						}
					`
					try {
						const response = await this.$httpService.graphql(queryHP)
					} catch (e) {
					}
					return
				}

				if (this.loading){
					return
				}
				this.loading = true
				this.validateOnChange = true
				this.setAllFieldsTouched()
				const validUserSelected = this.validUserTypeSelection()
				const validPlanSelected = this.validPlanSelection()
				const validLoginCredentials = await this.$validator.validateAll()

				if(!validPlanSelected || !validLoginCredentials || !validUserSelected){
					if(!validLoginCredentials){
						this.planSelectError = true
						this.generalMessageBody = 'Please correct errors in the form'
						this.generalMessageHeader = 'Whoops!'
						this.generalClass = 'danger'
						this.showAlert()
					}
					this.loading = false
					return
				}

				const name = `${this.firstName} ${this.lastName}`
				const cardNumber = this.cardNumber
				const cvc = this.cvc
				const expirationMonth = this.expiration.split('/')[0]
				const expirationYear = this.expiration.split('/')[1].slice(-2)
				const zipCode = this.zipCode

				if((!this.modalAlreadyShow && this.isUpgradeCandidate())){
					this.showModal()
					this.loading = false
					return
				}

				Stripe.card.createToken({
					number: cardNumber,
					cvc: cvc,
					exp_month: expirationMonth,
					exp_year: expirationYear,
					address_zip: zipCode
				}, this.stripeResponseHandler);

				return
			},

			async stripeResponseHandler(status, stripeResponse){
				if(stripeResponse.error){
					this.generalMessageBody = stripeResponse.error.message
					this.generalMessageHeader = 'Whoops!'
					this.generalClass = 'danger'
					this.loading = false
					return
				}

				this.firstSfcServerCall = false
				let user_logged_in = "0"
				if(this.$store.state.userIsLoggedIn){
					user_logged_in = "1"
				}

				let subscription_id = this.selectedMonthlyPlan
				if(this.typeOfSubscription == 'yearly'){
					subscription_id = this.selectedYearlyPlan
				}

				let couponCode = ""
				if(this.validCouponCodeApplied){
					couponCode = this.couponCode
				}

				const params = {
					mode: "signup",
					subscription_source: this.$route.query.subscription_source || document.referrer || "Not Defined",
					email: this.email,
					username: this.username,
					password: this.password,
					card_first: this.firstName,
					card_last: this.lastName,
					card_phone: this.phoneNumber,
					// card_address: "555 555 555",
					// card_city: "55555",
					// card_state: "FL",
					card_zip_code: this.zipCode,
					card_type: this.cardType,
					// card_company: "",
					user_interest: this.selectedUserType,
					terms_of_use: "1",
					subscription_id: subscription_id,
					subscription_coupon: couponCode,
					order_id: this.$route.query.order_id || "",
					trial_days: this.$route.query.trial_days || "0",
					user_logged_in: user_logged_in,
					user_id: this.$store.state.userId,
					stripe_token: stripeResponse.id,
					coming_from: 'new_signup'
				}

				const url = `${this.$store.state.config.sfcHost}/subscriptions/process_signup.php`
				const response = await this.$httpService.post(url, params, false)


				if(!response.success){
					this.generalMessageBody = response.message
					this.generalMessageHeader = 'Whoops!'
					this.generalClass = 'danger'
					this.showAlert()
					this.loading = false
				}else{

					// Track Heap
					if (heap) {
						heap.addUserProperties({"email": this.email});
					}

					const redirectUrl = `${this.$store.state.config.sfcHost}/pro-dashboard/`
					this.trackLinkedinPixel()
					this.trackGoogleAnalytics()


					if(response.login_token){
						const date = new Date()
						date.setTime(date.getTime() + (360 * 24 * 60 * 60))
						const expires = "; expires=" + date.toGMTString()
						document.cookie = encodeURIComponent('sfc_primary') + "=" + encodeURIComponent(response.login_token) + expires + "; domain=savingforcollege.com; path=/ ;"
					}
					setTimeout(()=>{ //we need time for set the cookie
						window.location.href = redirectUrl
					}, 4000)
				}
			},

			setCardType(){
				this.cardType = Stripe.card.cardType(this.cardNumber).toLowerCase()
			},

			trackGoogleAnalytics(){
				let eventLabel
				let eventValue
				if(this.typeOfSubscription == 'monthly'){
					if(this.selectedMonthlyPlan == '1'){
						eventLabel = 'Basic '
						eventValue = 2500
					}

					if(this.selectedMonthlyPlan == '10'){
						eventLabel = 'Gold Financial Pro '
						eventValue = 3500
					}

					if(this.selectedMonthlyPlan == '12'){
						eventLabel = 'Platinum Financial Pro '
						eventValue = 9900
					}
					eventLabel += "- Monthly"
				}else{
					if(this.selectedYearlyPlan == '2'){
						eventLabel = 'Basic '
						eventValue = 19900
					}

					if(this.selectedYearlyPlan == '3'){
						eventLabel = 'Gold Financial Pro '
						eventValue = 29900
					}

					if(this.selectedYearlyPlan == '7'){
						eventLabel = 'Platinum Financial Pro '
						eventValue = 74900
					}
					eventLabel += "- Yearly"
				}

				if(this.$route.query.xypn){
					SfcTrackingService.trackSubscribeXYPNPage(eventLabel, eventValue)
				}else{
					if(this.$route.query.capstone){
						SfcTrackingService.trackSubscribeCapstonePage(eventLabel, eventValue)
					}else{
						SfcTrackingService.trackSubscribePage(eventLabel, eventValue)
					}
				}

			},

			trackLinkedinPixel(){

				if(this.typeOfSubscription == 'monthly'){
					if(this.selectedMonthlyPlan == '1'){
						this.activePlan1or2 = true
					}

					if(this.selectedMonthlyPlan == '10'){
						this.activePlan3or10 = true
					}

					if(this.selectedMonthlyPlan == '12'){
						this.activePlan7or12 = false
					}
				}else{
					if(this.selectedYearlyPlan == '2'){
						this.activePlan1or2 = true
					}

					if(this.selectedYearlyPlan == '3'){
						this.activePlan3or10 = true
					}

					if(this.selectedYearlyPlan == '7'){
						this.activePlan7or12 = false
					}
				}
			}
		},

		head: {
			title: 'Subscribe to a Savingforcollege.com pro plan',
			meta: [
				{hid: "metatitle", name: 'title', content: 'Subscribe to a Savingforcollege.com pro plan'},
				{hid: "ogmetatitle", property: 'og:title', content: 'Subscribe to a Savingforcollege.com pro plan'},
				{hid: "metadescription", name: 'description', content: 'Subscribe and grow your advisory business with our premium professional 529 tools'},
				{hid: "ogmetadescription", property: 'og:description', content: 'Subscribe and grow your advisory business with our premium professional 529 tools'},
				{hid: "robots", name: 'robots', content: 'noindex, nofollow'}
			],
			__dangerouslyDisableSanitizers: ['title', 'meta']
		}

	}
</script>
